import React from 'react';
import { ArmchairIcon, ShuffleIcon, AlertTriangleIcon, EyeOffIcon } from 'lucide-react';
import { gluteImages, gluteProblemPoints } from '../../data/gluteCopy';
const icons = {
  sofa: ArmchairIcon,
  thief: ShuffleIcon,
  pain: AlertTriangleIcon,
  flat: EyeOffIcon
} as const;
export function GluteProblem() {
  return <section aria-labelledby="glute-problema" className="w-full bg-coal" data-id="element-162" data-mp="1biq2zgwftnxe">
      <div className="mx-auto w-full max-w-6xl px-5 py-16 sm:px-8 sm:py-24 lg:py-32" data-id="element-163" data-mp="nraypil3owji">
        <div className="grid gap-10 lg:grid-cols-[1fr_0.8fr] lg:items-center lg:gap-20" data-id="element-164" data-mp="jqimcggxmbj0">
          <div data-id="element-165" data-mp="xq0cp09vlwuh">
            <p className="text-[0.68rem] font-semibold uppercase tracking-[0.22em] text-ember" data-id="element-166" data-mp="xqjos0cuhr0l">
              El problema real
            </p>
            <h2 id="glute-problema" className="mt-5 text-[1.75rem] font-extrabold uppercase leading-[1.05] tracking-tight text-white sm:text-4xl lg:text-[2.75rem]" data-id="element-167" data-mp="spm5tlk0gsy1">
              Amnesia glútea
              <span className="block text-white/35" data-id="element-168" data-mp="2cduv0tua59s1">No es tu genética.</span>
            </h2>

            <div className="mt-7 space-y-5 text-[1.02rem] leading-relaxed text-white/60 sm:text-lg" data-id="element-169" data-mp="2hcxqbmkgk1mt">
              <p data-id="element-170" data-mp="2mc0uz5wj05u9">
                Sudas en la máquina de sentadillas y terminas agotada. Pero al mirarte de perfil,
                tus piernas crecen y tus glúteos siguen igual que el primer día.
              </p>
              <p className="text-lg font-medium text-white sm:text-xl" data-id="element-171" data-mp="1tnvb0ldaqkvh">
                Es un bloqueo neuromuscular: el músculo dejó de recibir la orden de trabajar.
              </p>
            </div>
          </div>

          <img src={gluteImages.mirror} alt="Mujer mirándose de perfil en el espejo del gimnasio" className="aspect-square w-full rounded-2xl object-cover" width={1024} height={1024} data-id="element-172" data-mp="23l9hbs5i9ta2" />
        </div>

        <div className="mt-14 grid gap-4 sm:mt-20 sm:grid-cols-2 sm:gap-5 lg:grid-cols-4" data-id="element-173" data-mp="1fvyiig7pu8yk">
          {gluteProblemPoints.map(point => {
          const Icon = icons[point.icon as keyof typeof icons];
          return <article key={point.title} className="flex h-full flex-col rounded-xl border border-coal-line bg-coal-card p-5 sm:p-6" data-id="element-174" data-mp="12wxq20cr3emk">
                <Icon className="h-6 w-6 text-ember" aria-hidden="true" data-id="element-175" data-mp="1clfpoe9anfom" />
                <h3 className="mt-4 text-[1rem] font-semibold text-white" data-id="element-176" data-mp="1cobp670sicf6">{point.title}</h3>
                <p className="mt-2 text-[0.9rem] leading-relaxed text-white/50" data-id="element-177" data-mp="oy7wgup53x2y">{point.text}</p>
              </article>;
        })}
        </div>
      </div>
    </section>;
}